import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';

const V3Header = ({ activeNav, primaryCta }) => {
  const { t, lang, toggleLang } = useLanguage();

  const navItems = [
    { key: 'leadership', to: '/leadership-development', label: t('common.navLeadership') },
    { key: 'hyperlocal', to: '/hyperlocal-platform', label: t('common.navHyperlocal') },
    { key: 'about', to: '/about', label: t('common.navAbout') },
    { key: 'blog', to: '/blog', label: t('common.navBlog') },
  ];

  return (
    <header className="v3-header">
      <Link to="/" className="v3-logo">BRAHMOID</Link>
      <nav className="v3-mainnav">
        {navItems.map(({ key, to, label }) => (
          <Link key={key} to={to} className={activeNav === key ? 'active' : ''}>
            {label}
          </Link>
        ))}
      </nav>
      <div className="v3-header-actions">
        <button
          type="button"
          className="v3-lang-toggle"
          onClick={toggleLang}
          aria-label={lang === 'hi' ? 'Switch to English' : 'हिंदी में बदलें'}
        >
          {lang === 'hi' ? 'EN' : 'हि'}
        </button>
        {primaryCta || (
          <>
            <Link to="/apply" className="v3-btn">{t('common.becomeCandidate')}</Link>
            <Link to="/sponsor-a-program" className="v3-btn primary">{t('common.becomeSponsor')}</Link>
          </>
        )}
      </div>
    </header>
  );
};

export default V3Header;
